import api from "../api";

export const getApiKey = async () => {
  try {
    const response = await api.get('mivulite/auth/api-key');
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const generateApiKey = async (macAddress) => {
  try {
    const response = await api.get(`mivulite/auth/api-key`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching config for device ${macAddress}:`, error);
    throw error;
  }
};

export const regenerateKey = async () => {
  try {
    const response = await api.post('mivulite/auth/api-key');
    return response.data;
  } catch (error) {
    console.error('Error regenerating API key:', error);
    throw error;
  }
};